// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"6d5d32e9","71":"36b115af","212":"8183d4f0","804":"925c041d","819":"f2d6dec9","869":"89930430","886":"2236177d","967":"55b27ce8"}[chunkId] + ".chunk.js";
};